<template>
    <div>
        <div id="header-container" class="pl-5">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white">
                <h3 class="text-white">{{ $t('Deposit Report') }}</h3>
                <span class="fz-16 fw-400">{{ $t('Your deposit report data can be seen here') }}</span>
            </div>
        </div>

        <b-container fluid class="mt-0 pb-5">
            <div id="body-container" class="overflow-auto">
                <b-row>
                    <b-col cols="12">
                        <h3 class="pl-3 pt-3 mb-3">{{ $t('History') }}</h3>

                        <div class="block-account p-3 mb-3 mt-1" v-for="item in data">
                            <div class="d-flex align-items-center">
                                <img :src="`${publicPath}/img/gep/${item.userType}.svg`" width="50px">
                                <div class="px-3 d-flex flex-column">
                                    <div class="fz-20 fw-700">{{ $t(userType[item.userType]) }}</div>
                                    <div class="fz-14 fw-400 text-grey7">{{ getDate(item.created_at) }}</div>
                                    <div class="fz-14 fw-400 text-grey7">{{ item.remitAccName }} - {{ item.remitAccNo }}</div>
                                </div>
                                <div :class="'ml-2 badge-default badge-' + getStatus(txt_status[item.status])">{{
                                    $t(txt_status[item.status]) }}</div>
                                <div class="px-3 ml-auto d-flex flex-column text-right">
                                    <div class="fz-20 fw-700 text-green">+{{ item.ccy }} {{
                                        getAmount(parseFloat(item.tradeTotalAmount)) }}</div>
                                    <div class="fz-14 fw-400 text-grey7">{{ getUserNo(item.userNo) }}</div>
                                </div>
                                <button class="btn bg-green text-white fs-12" @click="showUploadDoc(item.tradeNo)"
                                    v-if="item.status == 5">{{ $t('Upload supporting document') }}</button>
                                <div v-if="item.status == 2">
                                    <button class="btn btn-primary" @click=viewDetails(item)>{{ $t('View Details')
                                        }}</button>
                                </div>
                            </div>
                        </div>
                        <div v-if="data.length == 0" class="block-account p-3 mb-3 mt-1 text-center">
                            <span class="text-grey7">{{ $t('No Record Found') }}</span>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-container>

        <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
</template>



<script>

import LoaderComponent from "@/components/LoaderComponent";
import Account from '@/services/Account';
import CreateAccount from '@/services/CreateAccount';

import Global from '@/services/Global';
import moment from 'moment';

const USER_TYPE = {
    2: "China Enterprise",
    3: "Hong Kong Enterprise",
    5: "International"
}

const STATUS = {
    0: "Pending",
    1: "Pending",
    5: "Pending",
    2: "Approved",
    4: "Rejected"
};

export default {
    name: 'deposit',
    data() {
        return {
            publicPath: process.env.BASE_URL != '/' ? process.env.BASE_URL : '',
            isLoading: false,
            data: [],
            payerName: '',
            userType: USER_TYPE,
            txt_status: STATUS
        }
    },
    components: {
        LoaderComponent
    },
    methods: {
        viewDetails(param) {
            const parameter = {
                "title": "Proof of Deposit Details",
                "sub-title": "",
                "desc-title": "",
                "desc": "Deposit request has been approved from your RCPAY Virtual Banking account.",
                "table-title": "",
                "params": JSON.stringify({
                    "Currency": param['ccy'],
                    "Amount": this.getAmount(parseFloat(param['amount'])),
                    "Fee": this.getAmount(parseFloat(param['fee'])),
                    "Account Name": param['remitAccName'],
                    "Bank Account Number": param['bankAccountNo'],
                    "Remit Account Number": param['remitAccNo'],
                    "Date": moment(param['created_at']).format('DD/MM/YYYY'),
                    "Status": this.txt_status[param['status']].charAt(0).toUpperCase() + this.txt_status[param['status']].slice(1)
                })
            }

            const queryString = new URLSearchParams(parameter).toString();
            const url = `/document.html?${queryString}`;

            window.open(url, '_blank');
        },
        showUploadDoc(id) {
            this.$router.push({
                path: '/upload-deposit-remit-account',
                query: { "id": id }
            });
        },
        getStatus(txt) {
            return String(txt).toLowerCase();
        },
        getUserNo(user_no) {
            let userNo = user_no.match(/.{1,4}/g);
            for (let index = 0; index < userNo.length; index++) {
                if (index < userNo.length - 2) {
                    userNo[index] = "****";
                }
            }

            return userNo.join(" ");
        },
        getAmount(amount) {
            return Global.addCommas(amount);
        },
        getDate(date) {
            return moment(date).format('DD MMMM YYYY HH:mm:ss');
        },
        getData() {
            let self = this;
            Account.depositList().then((response) => {
                if (response.status == 200) {
                    self.isLoading = false;
                    self.data = response.data.data;
                    self.data = response.data.data.map(item => {
                        return {
                            ...item,
                            payerName: payerName || "Unknown Payer"
                        };
                    });
                }
            });
        }
    },
    mounted() {
        this.$nextTick(() => {
            CreateAccount.list({
                search: self.search,
                start: 0,
                length: -1
            }).then((response) => {
                if (response.status == 200) {
                    const data = response.data.data[0];
                    self.payerName = data.information.name;
                    this.getData();
                }
            });
        });
    }
};
</script>

<style scoped>
.card-header {
    background-color: unset !important;
    border: unset !important;
}

.block-account {
    background: #F8F9FA;
    border-radius: 8px;
}

.fs-12 {
    font-size: 12px !important;
}
</style>